import React from 'react'
import { css } from '@emotion/react'
import { Link, Typography } from '../base-ui'
import { IoLogoFacebook, IoLogoInstagram, IoLogoLinkedin } from 'react-icons/io5'

function UsefulLinks() {
    const style = css`
        padding: 3rem;
        .title{
            margin-bottom: 2rem;
        }
        ul {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            list-style: inside;
            li {
                font-size: 1rem;
                font-weight: 600;
                padding: 0.5rem 0;
            }
        }
    `
    return (<div css={style}>
        <Typography type="h4" className="title" fontWeight="Semi Bold">Usefull Link</Typography>
        <ul>
            <li><Link href="/about">About Us</Link></li>
            <li><Link href="/contact">Contact Us</Link></li>
            <li style={{ listStyle: 'none' }}>
                <Link external rel="nofollow" href="https://www.instagram.com/nour_alzomorod.co" >
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}><IoLogoInstagram /> Follow on Instagram</span>
                </Link>
            </li>
            <li style={{ listStyle: 'none' }}>
                <Link external rel="nofollow" href="http://www.linkedin.com/in/nour-alzomorod-9b8b59311" >
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}><IoLogoLinkedin /> Follow on Linkedin</span>
                </Link>
            </li>
            <li style={{ listStyle: 'none' }}>
                <Link external rel="nofollow" href="https://www.facebook.com/profile.php?id=61559426597641&mibextid=LQQJ4d" >
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}><IoLogoFacebook /> Follow on Facebook</span>
                </Link>
            </li>
        </ul>

    </div>
    )
}

export default UsefulLinks